import React, { useState, useRef } from 'react';
import { View, StyleSheet, Image, TouchableOpacity, Dimensions } from 'react-native';
// @ts-ignore
import Carousel, { Pagination } from "react-native-snap-carousel";

const { width: screenWidth } = Dimensions.get('window');

interface BannerData {
  url?: string;
  nav_to?: string;
  tags?: any;
  [key: string]: any;
}

interface ImageBannerProps {
  data: BannerData | BannerData[];
  onPress?: (item?: BannerData, index?: number) => void;
}

const BannerList: React.FC<ImageBannerProps> = ({ data, onPress }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef<any>(null);

  if (Array.isArray(data) && data.length === 0) {
    return null;
  }

  if (Array.isArray(data) && data.length > 1) {
    const banners = data.filter(item => item.url);
    if (banners.length === 0) return null;

    const renderItem = ({ item, index }: { item: BannerData; index: number }) => (
      <TouchableOpacity
        style={styles.carouselItem}
        onPress={() => onPress?.(item, index)}
        activeOpacity={0.8}
      >
        <Image
          source={{ uri: item.url }}
          style={styles.carouselImage}
          resizeMode="cover"
        />
      </TouchableOpacity>
    );

    return (
      <View style={styles.carouselContainer}>
        <View style={{}}>
          <Carousel
            layout="default"
            data={banners}
            ref={carouselRef}
            renderItem={renderItem}
            sliderWidth={screenWidth - 24}
            itemWidth={screenWidth - 80}
            enableSnap={true}
            loop={true}
            loopClonesPerSide={banners.length}
            onSnapToItem={(index: number) => setCurrentIndex(index)}
            inactiveSlideScale={0.9}
            inactiveSlideOpacity={0.7}
            activeSlideAlignment="center"
          />
          <Pagination
            dotsLength={banners.length}
            activeDotIndex={currentIndex}
            inactiveDotStyle={{ height: 4, width: 4, borderRadius: 2 }}
            dotStyle={{ height: 6, width: 6, borderRadius: 3 }}
            dotColor="#333333"
            inactiveDotColor="#CCCCCC"
            inactiveDotScale={1}
            carouselRef={carouselRef}
            dotContainerStyle={{ marginHorizontal: 2 }}
            containerStyle={{ paddingVertical: 0, paddingTop: 10 }}
          />
        </View>

      </View>
    );
  }

  // Handle object format - display single banner
  if (Array.isArray(data) && data.length === 1) {
    const banners1 = data.filter(item => item.url);
    if (banners1.length === 0) return null;

    return (
      <TouchableOpacity
        style={styles.container}
        onPress={() => onPress?.(banners1[0])}
        activeOpacity={0.8}
      >
        <Image
          source={{ uri: banners1[0].url }}
          style={styles.image}
          resizeMode="cover"
        />
      </TouchableOpacity>
    );
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 8,
    marginVertical: 8,
  },
  image: {
    width: '100%',
    height: 120,
    borderRadius: 16,
  },
  carouselContainer: {
    marginVertical: 8,
  },
  carouselItem: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    width: '100%',
    height: 84,
    overflow: 'hidden',
  },
  carouselImage: {
    width: '100%',
    height: '100%',
    borderRadius: 16,
  },
  paginationContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 4,
  },
  dotsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  dot: {
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: '#CCCCCC',
    marginHorizontal: 2,
  },
  activeDot: {
    backgroundColor: '#333333',
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  counterContainer: {
    backgroundColor: '#333333',
    paddingHorizontal: 8,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',

  },
  counterText: {
    color: '#FFFFFF',
    fontSize: 6,
    fontWeight: '600',
    textAlign: 'center',
    textAlignVertical: 'center',
  },
});

export default BannerList;